module.exports = __webpack_public_path__ + "static/CynthiaDLima-6dbea516705e6bdd1413cf2c5fc402ed.jpg";